const prenom = document.getElementById('prospect_first_name')
const nom = document.getElementById('prospect_last_name')
const age = document.getElementById('prospect_age')
const email = document.getElementById('prospect_email')
const phone = document.getElementById('prospect_phone_number')
const recommandation = document.getElementById('prospect_come_from')
const motivation = document.getElementById('prospect_motivation')

const regExNames = /^[a-zàáâäçèéêëìíîïñòóôöùúûüÂÇÉÈÊËÎÏÔÖÙÜ ,.'-]+$/i
const regExAge = /\s[0-1]{1}[0-9]{0,2}/
const regExEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const regExPhone = /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/

let prenomCheck = 0
let nomCheck = 0
let ageCheck = 0
let emailCheck = 0
let phoneCheck = 0
let recommandationCheck = 0
let motivationCheck = 0


function checkForm() {
  let totalCheck = prenomCheck + nomCheck + ageCheck + emailCheck + phoneCheck + recommandationCheck + motivationCheck
  if (totalCheck == 6 ) {
return true  }
}

prenom.addEventListener('focusout', function(e) {
  if (regExNames.test(prenom.value)) {
    prenomCheck = 1
    document.getElementById('prenom-alert').style.display = "none"
    checkForm()
  } else {
    prenomCheck = 0
    document.getElementById('prenom-alert').style.display = "block"
  }
})

nom.addEventListener('focusout', function(e) {
  if (regExNames.test(nom.value)) {
    nomCheck = 1
    document.getElementById('nom-alert').style.display = "none"
    checkForm()
  } else {
    nomCheck = 0
    document.getElementById('nom-alert').style.display = "block"
  }
})

age.addEventListener('focusout', function(e) {
  if (17 < age.value && age.value < 150) {
    ageCheck = 1
    document.getElementById('age-alert').style.display = "none"
    checkForm()
  } else {
    ageCheck = 0
    document.getElementById('age-alert').style.display = "block"
  }
})

email.addEventListener('focusout', function(e) {
  if (regExEmail.test(email.value)) {
    emailCheck = 1
    document.getElementById('email-alert').style.display = "none"
    checkForm()
  } else {
    emailCheck = 0
    document.getElementById('email-alert').style.display = "block"
  }
})

phone.addEventListener('focusout', function(e) {
  if (regExPhone.test(phone.value)) {
    phoneCheck = 1
    document.getElementById('phone-alert').style.display = "none"
    checkForm()
  } else {
    phoneCheck = 0
    document.getElementById('phone-alert').style.display = "block"
  }
})

// recommandation.addEventListener('focusout', function(e) {
//   if (recommandation.value.length >= 3) {
//     recommandationCheck = 1
//     document.getElementById('recommandation-alert').style.display = "none"
//     checkForm()
//   } else {
//     recommandationCheck = 0
//     document.getElementById('recommandation-alert').style.display = "block"
//   }
// })


motivation.addEventListener('keyup', function(e) {
  document.getElementById("motivation-value").classList.remove("hidden")
  let length = motivation.value.length
  if (length >= 70) {
    document.getElementById('motivation-value').innerHTML = "Parfait :)"
    document.getElementById('motivation-value').style.color = "#00E5FF"
    motivationCheck = 1
    checkForm()
  } else {
    motivationCheck = 0
    document.getElementById('motivation-value').innerHTML = `${70 - length} caractères restants`
  }

})
